export function capitalizeFirstLetter(string) {
    if (!string) return '';
    const str = String(string);
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

export function safeToUpperCase(str) {
  return typeof str === 'string' ? str.toUpperCase() : '';
}